import { RefreshCw, WifiOff } from 'lucide-react'
import { useT } from '../../hooks/useTranslation'

/**
 * Экран сбоя ЗАГРУЗКИ приложения (п.3 task.txt: «мини-апп иногда не
 * открывается»). Раньше в таких случаях пользователь видел белый экран или
 * пустое приложение без единого слова о причине — по жалобе невозможно было
 * понять, что произошло.
 *
 * Используется в двух местах:
 *  • src/main.jsx — SDK Telegram не загрузился за отведённое время
 *    (telegram-web-app.js не ответил: сеть/фильтрация);
 *  • src/App.jsx — критичный сбой загрузки данных (getMe не отдал профиль:
 *    нет сети или отклонена авторизация).
 *
 * Вид намеренно повторяет ErrorPage («Технические неполадки»), чтобы сбои
 * выглядели единообразно. Тексты задаются КЛЮЧАМИ переводов, а не строками,
 * поэтому экран локализуется как остальное приложение.
 */
export default function BootError({ titleKey, hintKey, onRetry, error }) {
  const t = useT()
  return (
    <div style={{
      background: '#0A0A0A',
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      position: 'relative',
      overflow: 'hidden',
      textAlign: 'center',
    }}>
      <div aria-hidden="true" style={{
        position: 'absolute', top: 0, right: 0,
        width: '92%', height: '52%',
        background: 'radial-gradient(ellipse at 100% 0%, rgba(220,75,15,0.72) 0%, rgba(195,58,10,0.38) 28%, rgba(160,40,5,0.14) 55%, transparent 75%)',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 320 }}>
        <div style={{
          width: 80, height: 80, borderRadius: 22, margin: '0 auto 28px',
          background: 'linear-gradient(135deg, rgba(255,107,53,0.15) 0%, rgba(249,115,26,0.08) 100%)',
          border: '1px solid rgba(255,107,53,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <WifiOff size={38} color="#34D399" />
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#fff', marginBottom: 10 }}>
          {t[titleKey] ?? t.bootLoadFailed}
        </h1>
        <p style={{ fontSize: 15, color: '#8E8E93', lineHeight: 1.65, marginBottom: 36 }}>
          {t[hintKey] ?? t.bootLoadFailedHint}
        </p>

        <button
          onClick={onRetry}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '14px 32px', borderRadius: 14,
            background: 'linear-gradient(135deg, #34D399 0%, #10B981 100%)',
            color: '#fff', fontSize: 15, fontWeight: 700,
            border: 'none', cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(52,211,153,0.30)',
          }}
        >
          <RefreshCw size={17} />
          {t.tryAgain}
        </button>

        {/* Текст ошибки — мелким, для поддержки: юзер не всегда может открыть
            консоль, а по тексту причина видна сразу. */}
        {error?.message && (
          <p style={{
            marginTop: 18, fontSize: 10.5, color: '#4A4A4D',
            lineHeight: 1.5, wordBreak: 'break-word', maxWidth: 300,
          }}>
            {String(error.message)}
          </p>
        )}
      </div>
    </div>
  )
}
